import React from 'react';
import {
  Avatar,
  Box,
  IconButton,
  Icons,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@ublend-npm/aulaui-core';
import useIsOverflowing from '@app/hooks/useIsOverflowing';
import {
  ExtensionStudent,
  ManageExtensionStyles,
} from './ManageExtension.types';

type Props = {
  canAdd?: boolean;
  isSelected: boolean;
  onToggle: (studentId: string) => void;
  showAction?: boolean;
  student: ExtensionStudent;
  styles: ManageExtensionStyles;
};

const StudentRow = ({
  canAdd = false,
  isSelected,
  onToggle,
  showAction = true,
  student,
  styles,
}: Props) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [nameRef, isNameOverflowing] = useIsOverflowing<HTMLDivElement>();
  const [emailRef, isEmailOverflowing] = useIsOverflowing<HTMLDivElement>();
  return (
    <Box component="li" sx={styles.studentRow}>
      <Avatar src={student.avatar} sx={styles.avatar}>
        {student.fullName?.charAt(0)}
      </Avatar>
      <Box sx={styles.studentDetails}>
        <Box sx={styles.studentName}>
          <Tooltip
            title={student.fullName || ''}
            disableFocusListener={!isMdUp || !isNameOverflowing}
            disableHoverListener={!isMdUp || !isNameOverflowing}
            disableTouchListener={!isMdUp || !isNameOverflowing}
          >
            <Box ref={nameRef} sx={styles.studentNameText}>
              {student.fullName}
            </Box>
          </Tooltip>
          {isSelected && (
            <Box component="span" sx={styles.added}>
              - Added
            </Box>
          )}
        </Box>
        <Tooltip
          title={student.email || ''}
          disableFocusListener={!isMdUp || !isEmailOverflowing}
          disableHoverListener={!isMdUp || !isEmailOverflowing}
          disableTouchListener={!isMdUp || !isEmailOverflowing}
        >
          <Box ref={emailRef} sx={styles.studentEmail}>
            {student.email}
          </Box>
        </Tooltip>
      </Box>
      {showAction && (
        <IconButton
          type="button"
          aria-label={`${canAdd && !isSelected ? 'Add' : 'Remove'} ${
            student.fullName
          }`}
          onClick={() => onToggle(student.id)}
          sx={canAdd && !isSelected ? styles.addStudent : styles.removeStudent}
        >
          {canAdd && !isSelected ? <Icons.AddCircle /> : <Icons.RemoveCircle />}
        </IconButton>
      )}
    </Box>
  );
};

export default StudentRow;
